import React, { useEffect, useRef } from 'react';
import { KEY_CONTENT_ROUTES } from '../../../../routing';
import trustpilotImg from 'static/img/home/hero/trustpilot.svg';

import LazyLoad from 'react-lazyload';
import CompletedIcon from 'components/IconModule/icons/completed';
import { openChatWidget } from 'utils/chat';
import css from './hero.module.scss';

const Hero = () => {
  const imgBlock = useRef<HTMLDivElement | null>();

  const onScroll = () => {
    if (imgBlock.current) {
      const posY = document.documentElement.scrollTop * 0.3;

      if (window.innerWidth > 1700) {
        imgBlock.current.style.transform = `translateY(${(posY - 120)}px)`;
      } else if (window.innerWidth > 1000) {
        imgBlock.current.style.transform = `translateX(50px) translateY(${posY + 50}px) scale(1.6)`;
      } else {
        imgBlock.current.style.transform = `translateX(60px) translateY(${posY + 70}px) scale(2.15)`;
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className={css.heroWrap}>
      <div className={css.left}></div>

      <div className={css.right}>
        <div className={css.image}>
          <LazyLoad>
            <img src={`${process.env.PUBLIC_URL}/hero-bg.jpg`} alt='hero-image' ref={(x) => imgBlock.current = x} />
          </LazyLoad>
        </div>
      </div>
      <div className={css.content}>
        <div className="container">
          <div className={css.contentLeftWrapper}>
            <div className={css.heroText}>Online <span>tutoring</span> made simple.</div>

            <div className={css.heroDescr}>Improve your grades and boost your confidence today with our experienced online tutors.</div>
            <div className={css.mobile}>
              <div className={css.bottomLinks}>
                <div>
                  <LazyLoad>
                    <img src={trustpilotImg} alt="" />
                  </LazyLoad>
                  </div>
              </div>
            </div>
           <div className={css.heroLinks}>
              <a
                className="btn-primary"
                href={KEY_CONTENT_ROUTES.SEARCH_RESULTS}
                rel="noopener noreferrer"
              >
                Find a Tutor
              </a>
              Or
              <span onClick={openChatWidget}>Speak to an Expert</span>
            </div>
            <div className={css.features}>
              <span className={css.featureItem}><CompletedIcon /> First Lesson FREE</span>
              <span className={css.featureItem}><CompletedIcon /> Trained & Qualified Tutors </span>
              <span className={css.featureItem}><CompletedIcon /> No Commitment</span>
            </div>
            <div className={css.desktop}>
              <div className={css.bottomLinks}>
                <div className={css.ratedLabel}>Rated Excellent</div>
                <div>
                  <LazyLoad>
                    <img src={trustpilotImg} alt="" />
                  </LazyLoad>
                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
